export const TENANTS = {
    ucc: {
      key: 'ucc',
  
      tokens: {
        // ─────────────────────────────────────────────────────────────
        // A) Institution & Location
        // ─────────────────────────────────────────────────────────────
        UNIVERSITY_NAME: 'University College Cork',
        UNIVERSITY_SHORT: 'UCC',
        UNIVERSITY_REGION: 'Cork',
  
        // ─────────────────────────────────────────────────────────────
        // B) University Health & Counselling
        // ─────────────────────────────────────────────────────────────
        STUDENT_HEALTH_LABEL: 'Student Health Department',
        STUDENT_HEALTH_PHONE_DISPLAY: '021 490 2311',
        STUDENT_HEALTH_PHONE_TEL: '+353214902311',
        STUDENT_HEALTH_EMAIL: '',
        STUDENT_HEALTH_WEBSITE:
          'https://www.ucc.ie/en/studenthealth/',
  
        COUNSELLING_LABEL:
          'Student Counselling and Development',
        COUNSELLING_PHONE_DISPLAY: '',
        COUNSELLING_PHONE_TEL: '',
        COUNSELLING_EMAIL: 'counselling@ucc.ie',
        COUNSELLING_WEBSITE:
          'https://www.ucc.ie/en/studentcounselling/',
  
        // Optional convenience tokens
        STUDENT_HEALTH_CONTACT:
          '[021 490 2311](tel:+353214902311)',
  
        COUNSELLING_CONTACT:
          '[counselling@ucc.ie](mailto:counselling@ucc.ie)',
  
        // ─────────────────────────────────────────────────────────────
        // C) Crisis Text Line
        // ─────────────────────────────────────────────────────────────
        CRISIS_TEXT_LABEL: 'Crisis Text Line',
        CRISIS_TEXT_NUMBER_DISPLAY: '50808',
        CRISIS_TEXT_NUMBER_TEL: '50808',
        CRISIS_TEXT_FORMATTED:
          'Text UCC to [50808](tel:50808)',
        CRISIS_TEXT_CONTACT:
          '[086 180 0280](tel:+353861800280)',
  
        // ─────────────────────────────────────────────────────────────
        // D) Regional Supports
        // ─────────────────────────────────────────────────────────────
        REGIONAL_ADULT_ADDICTION_LABEL:
          'HSE South Adult Addiction Service',
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY:
          '021 496 8933',
        REGIONAL_ADULT_ADDICTION_PHONE_TEL:
          '+353214968933',
        REGIONAL_ADULT_ADDICTION_EMAIL: '',
        REGIONAL_ADULT_ADDICTION_WEBSITE: '',
  
        REGIONAL_DRUG_ALCOHOL_LABEL:
          'HSE South Drug & Alcohol Service',
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY:
          '021 493 0100',
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL:
          '+353214930100',
        REGIONAL_DRUG_ALCOHOL_EMAIL: '',
        REGIONAL_DRUG_ALCOHOL_WEBSITE: '',
  
        REGIONAL_TREATMENT_LABEL:
          'Fellowship House',
        REGIONAL_TREATMENT_PHONE_DISPLAY:
          '021 454 5984',
        REGIONAL_TREATMENT_PHONE_TEL:
          '+353214545984',
        REGIONAL_TREATMENT_EMAIL:
          'fellowship@eircom.net',
        REGIONAL_TREATMENT_WEBSITE: '',
  
        REGIONAL_ADULT_ADDICTION_CONTACT:
          '[021 496 8933](tel:+353214968933)',
  
        REGIONAL_TREATMENT_CONTACT:
          '[021 454 5984](tel:+353214545984) or [fellowship@eircom.net](mailto:fellowship@eircom.net)',
  
        // ─────────────────────────────────────────────────────────────
        // UL-only service
        // ─────────────────────────────────────────────────────────────
        SUGS_LABEL: '',
        SUGS_EMAIL: '',
        SUGS_WEBSITE: '',
        SUGS_CONTACT: '',
        SUGS_SUPPORT_BULLET: '',
  
        // ─────────────────────────────────────────────────────────────
        // E) University / Students’ Union Supports
        // ─────────────────────────────────────────────────────────────
        SU_WELFARE_LABEL:
          'Students’ Union welfare officer',
        SU_WELFARE_EMAIL: 'suwelfare@ucc.ie',
        SU_WELFARE_WEBSITE: '',
  
        BUDGETING_LABEL:
          'Student budgeting advice',
        BUDGETING_EMAIL:
          'studentbudgetingadvice@ucc.ie',
        BUDGETING_WEBSITE: '',
  
        SUPPORT_TREE_LABEL: 'UCC Support Tree',
        SUPPORT_TREE_URL:
          'https://www.ucc.ie/en/media/support/studentexperience/SupportTreeInfographic.pdf',
  
        // ─────────────────────────────────────────────────────────────
        // F) Legal & Safety
        // ─────────────────────────────────────────────────────────────
        FLAC_LABEL:
          'Cork City FLAC Legal Advice Centre',
        FLAC_PHONE_DISPLAY: '01 906 1010',
        FLAC_PHONE_TEL: '+35319061010',
      },
    },
  
    ul: {
      key: 'ul',
  
      tokens: {
        // ─────────────────────────────────────────────────────────────
        // A) Institution & Location
        // ─────────────────────────────────────────────────────────────
        UNIVERSITY_NAME: 'University of Limerick',
        UNIVERSITY_SHORT: 'UL',
        UNIVERSITY_REGION: 'Limerick',
  
        // ─────────────────────────────────────────────────────────────
        // B) University Health & Counselling
        // ─────────────────────────────────────────────────────────────
        STUDENT_HEALTH_LABEL:
          'Student Health Centre',
        STUDENT_HEALTH_PHONE_DISPLAY:
          '061 202534',
        STUDENT_HEALTH_PHONE_TEL:
          '+35361202534',
        STUDENT_HEALTH_EMAIL:
          'studenthealthcentre@ul.ie',
        STUDENT_HEALTH_WEBSITE:
          'https://www.ul.ie/student-affairs/student-health-centre',
  
        COUNSELLING_LABEL:
          'Student Counselling and Wellbeing Service',
        COUNSELLING_PHONE_DISPLAY:
          '061 202327',
        COUNSELLING_PHONE_TEL:
          '+35361202327',
        COUNSELLING_EMAIL:
          'counselling@ul.ie',
        COUNSELLING_WEBSITE:
          'https://www.ul.ie/student-affairs/counselling-service',
  
        STUDENT_HEALTH_CONTACT:
          '[061 202534](tel:+35361202534) or [studenthealthcentre@ul.ie](mailto:studenthealthcentre@ul.ie)',
  
        COUNSELLING_CONTACT:
          '[061 202327](tel:+35361202327) or [counselling@ul.ie](mailto:counselling@ul.ie)',
  
        // ─────────────────────────────────────────────────────────────
        // C) Crisis Text Line
        // ─────────────────────────────────────────────────────────────
        CRISIS_TEXT_LABEL: 'Crisis Text Line',
        CRISIS_TEXT_NUMBER_DISPLAY: '50808',
        CRISIS_TEXT_NUMBER_TEL: '50808',
        CRISIS_TEXT_FORMATTED:
          'Text UL to [50808](tel:50808)',
        CRISIS_TEXT_CONTACT:
          'Text UL to [50808](tel:50808)',
  
        // ─────────────────────────────────────────────────────────────
        // D) Regional Supports
        // ─────────────────────────────────────────────────────────────
        REGIONAL_ADULT_ADDICTION_LABEL:
          'Mid-West Regional Drugs & Alcohol Forum',
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY: '',
        REGIONAL_ADULT_ADDICTION_PHONE_TEL: '',
        REGIONAL_ADULT_ADDICTION_EMAIL: '',
        REGIONAL_ADULT_ADDICTION_WEBSITE:
          'https://www.mwrdtf.ie/supports/',
  
        REGIONAL_DRUG_ALCOHOL_LABEL:
          'HSE Mid-West Limerick Drug and Alcohol Service',
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY:
          '061 318633',
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL:
          '+35361318633',
        REGIONAL_DRUG_ALCOHOL_EMAIL: '',
        REGIONAL_DRUG_ALCOHOL_WEBSITE: '',
  
        REGIONAL_TREATMENT_LABEL:
          'Community Substance Misuse Team',
        REGIONAL_TREATMENT_PHONE_DISPLAY:
          '061 318904',
        REGIONAL_TREATMENT_PHONE_TEL:
          '+35361318904',
        REGIONAL_TREATMENT_EMAIL: '',
        REGIONAL_TREATMENT_WEBSITE: '',
  
        REGIONAL_ADULT_ADDICTION_CONTACT:
          '[Supports](https://www.mwrdtf.ie/supports/)',
  
        REGIONAL_TREATMENT_CONTACT:
          '[061 318904](tel:+35361318904)',
  
        // ─────────────────────────────────────────────────────────────
        // SUGS — UL only
        // ─────────────────────────────────────────────────────────────
        SUGS_LABEL:
          'Substance Use and Gambling Support Service (SUGS)',
        SUGS_EMAIL: 'sugs@ul.ie',
        SUGS_WEBSITE:
          'https://www.ul.ie/healthy-ul/wellbeing-resources/addiction/substance-use-and-gambling-support-service',
  
        SUGS_CONTACT:
          '[sugs@ul.ie](mailto:sugs@ul.ie) or [website](https://www.ul.ie/healthy-ul/wellbeing-resources/addiction/substance-use-and-gambling-support-service)',
  
        SUGS_SUPPORT_BULLET:
          '* Substance Use and Gambling Support Service (SUGS): [sugs@ul.ie](mailto:sugs@ul.ie) or [website](https://www.ul.ie/healthy-ul/wellbeing-resources/addiction/substance-use-and-gambling-support-service)',
  
        // ─────────────────────────────────────────────────────────────
        // E) University / Students’ Union Supports
        // ─────────────────────────────────────────────────────────────
        SU_WELFARE_LABEL:
          'Student Life Welfare Officer',
        SU_WELFARE_EMAIL:
          'studentwelfare@ul.ie',
        SU_WELFARE_WEBSITE: '',
  
        BUDGETING_LABEL:
          'Student financial support advice service',
        BUDGETING_EMAIL:
          'student.budgeting@ul.ie',
        BUDGETING_WEBSITE: '',
  
        SUPPORT_TREE_LABEL:
          'UL Student Affairs',
        SUPPORT_TREE_URL:
          'https://www.ul.ie/student-affairs',
  
        // ─────────────────────────────────────────────────────────────
        // F) Legal & Safety
        // ─────────────────────────────────────────────────────────────
        FLAC_LABEL:
          'FLAC Legal Advice Centre Limerick',
        FLAC_PHONE_DISPLAY: '01 906 10 10',
        FLAC_PHONE_TEL: '+35319061010',
      },
    },
  
    setu: {
      key: 'setu',
  
      tokens: {
        // ─────────────────────────────────────────────────────────────
        // A) Institution & Location
        // ─────────────────────────────────────────────────────────────
        UNIVERSITY_NAME:
          'South East Technological University',
        UNIVERSITY_SHORT: 'SETU',
        UNIVERSITY_REGION: 'South East',
        MAIN_WEBSITE: 'https://www.setu.ie/',
  
        // ─────────────────────────────────────────────────────────────
        // B) University Health & Counselling
        // Base fallback until campus is selected
        // ─────────────────────────────────────────────────────────────
        STUDENT_HEALTH_LABEL:
          'SETU Student Health / Medical Service',
        STUDENT_HEALTH_PHONE_DISPLAY:
          '+353 818 121212',
        STUDENT_HEALTH_PHONE_TEL:
          '+353818121212',
        STUDENT_HEALTH_EMAIL:
          'support@myuse.ie',
        STUDENT_HEALTH_WEBSITE:
          'https://www.setu.ie/current-students/student-support-services/medical-services',
  
        COUNSELLING_LABEL:
          'SETU Student Counselling Service',
        COUNSELLING_PHONE_DISPLAY:
          '+353 818 121212',
        COUNSELLING_PHONE_TEL:
          '+353818121212',
        COUNSELLING_EMAIL:
          'support@myuse.ie',
        COUNSELLING_WEBSITE:
          'https://www.setu.ie/current-students/student-support-services/counselling-service',
  
        STUDENT_HEALTH_CONTACT:
          '[SETU Medical Services](https://www.setu.ie/current-students/student-support-services/medical-services)',
  
        COUNSELLING_CONTACT:
          '[SETU Counselling Service](https://www.setu.ie/current-students/student-support-services/counselling-service)',
  
        // ─────────────────────────────────────────────────────────────
        // C) Crisis Text Line
        // ─────────────────────────────────────────────────────────────
        CRISIS_TEXT_LABEL:
          'Text About It (24/7)',
        CRISIS_TEXT_NUMBER_DISPLAY: '50808',
        CRISIS_TEXT_NUMBER_TEL: '50808',
        CRISIS_TEXT_FORMATTED:
          'Text HELLO to [50808](tel:50808)',
        CRISIS_TEXT_CONTACT:
          'Text HELLO to [50808](tel:50808) (backup: [086 1800 280](tel:+353861800280))',
  
        // ─────────────────────────────────────────────────────────────
        // D) Regional / National Drug & Alcohol Supports
        // ─────────────────────────────────────────────────────────────
        REGIONAL_ADULT_ADDICTION_LABEL:
          'HSE Drugs & Alcohol Helpline',
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY:
          '1800 459 459',
        REGIONAL_ADULT_ADDICTION_PHONE_TEL:
          '1800459459',
        REGIONAL_ADULT_ADDICTION_EMAIL:
          'helpline@hse.ie',
        REGIONAL_ADULT_ADDICTION_WEBSITE:
          'https://www.drugs.ie/phone/',
  
        REGIONAL_DRUG_ALCOHOL_LABEL:
          'HSE Drugs & Alcohol Helpline',
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY:
          '1800 459 459',
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL:
          '1800459459',
        REGIONAL_DRUG_ALCOHOL_EMAIL:
          'helpline@hse.ie',
        REGIONAL_DRUG_ALCOHOL_WEBSITE:
          'https://www.drugs.ie/phone/',
  
        REGIONAL_TREATMENT_LABEL:
          'Drugs.ie Services Directory',
        REGIONAL_TREATMENT_PHONE_DISPLAY:
          '1800 459 459',
        REGIONAL_TREATMENT_PHONE_TEL:
          '1800459459',
        REGIONAL_TREATMENT_EMAIL:
          'helpline@hse.ie',
        REGIONAL_TREATMENT_WEBSITE:
          'https://www.drugs.ie/services/',
  
        REGIONAL_ADULT_ADDICTION_CONTACT:
          '[1800 459 459](tel:1800459459) or [helpline@hse.ie](mailto:helpline@hse.ie)',
  
        REGIONAL_TREATMENT_CONTACT:
          '[Drugs.ie services directory](https://www.drugs.ie/services/) or [1800 459 459](tel:1800459459)',
  
        // ─────────────────────────────────────────────────────────────
        // UL-only service: not applicable to SETU
        // ─────────────────────────────────────────────────────────────
        SUGS_LABEL:
          'Not applicable for SETU',
        SUGS_EMAIL: 'support@myuse.ie',
        SUGS_WEBSITE:
          'https://www.setu.ie/current-students/student-support-services',
        SUGS_CONTACT:
          'Not applicable for SETU',
        SUGS_SUPPORT_BULLET: '',
  
        // ─────────────────────────────────────────────────────────────
        // E) University / Students’ Union Supports
        // ─────────────────────────────────────────────────────────────
        SU_WELFARE_LABEL:
          'SETU Students’ Union welfare/support',
        SU_WELFARE_EMAIL:
          'support@myuse.ie',
        SU_WELFARE_WEBSITE:
          'https://www.setu.ie/current-students/student-support-services/student-union',
  
        BUDGETING_LABEL:
          'SETU Student Assistance Fund / financial support',
        BUDGETING_EMAIL:
          'support@myuse.ie',
        BUDGETING_WEBSITE:
          'https://www.setu.ie/current-students/student-support-services/student-assistance-fund-saf',
  
        SUPPORT_TREE_LABEL:
          'SETU Student Support Services',
        SUPPORT_TREE_URL:
          'https://www.setu.ie/current-students/student-support-services',
  
        // ─────────────────────────────────────────────────────────────
        // F) Legal & Safety
        // ─────────────────────────────────────────────────────────────
        FLAC_LABEL:
          'Free Legal Advice Centres (FLAC)',
        FLAC_PHONE_DISPLAY: '01 906 1010',
        FLAC_PHONE_TEL: '+35319061010',
      },
  
      campuses: {
        waterford: {
          label: 'Waterford',
  
          tokens: {
            UNIVERSITY_REGION: 'Waterford',
  
            CAMPUS_NAME: 'Waterford',
            CAMPUS_ADDRESS:
              'Cork Road, Waterford City, Co. Waterford, X91 K0EK',
            CAMPUS_PHONE_DISPLAY:
              '+353 818 121212',
            CAMPUS_PHONE_TEL:
              '+353818121212',
            CAMPUS_EMAIL: 'info.wd@setu.ie',
            CAMPUS_WEBSITE:
              'https://www.setu.ie/about/setu-campuses/waterford-campuses',
  
            STUDENT_HEALTH_LABEL:
              'SETU Waterford Student Medical Service',
            STUDENT_HEALTH_PHONE_DISPLAY:
              '051 302 873',
            STUDENT_HEALTH_PHONE_TEL:
              '+35351302873',
            STUDENT_HEALTH_EMAIL:
              'info.wd@setu.ie',
            STUDENT_HEALTH_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-waterford',
  
            COUNSELLING_LABEL:
              'SETU Waterford Student Counselling Service',
            COUNSELLING_PHONE_DISPLAY:
              '051 302 091',
            COUNSELLING_PHONE_TEL:
              '+35351302091',
            COUNSELLING_EMAIL:
              'info.wd@setu.ie',
            COUNSELLING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/counselling-service/counselling-services-waterford',
  
            STUDENT_HEALTH_CONTACT:
              '[051 302 873](tel:+35351302873) or [Waterford medical services page](https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-waterford)',
  
            COUNSELLING_CONTACT:
              '[051 302 091](tel:+35351302091) or [Waterford counselling service page](https://www.setu.ie/current-students/student-support-services/counselling-service/counselling-services-waterford)',
  
            SU_WELFARE_LABEL:
              'SETU Students’ Union welfare/support',
            SU_WELFARE_EMAIL:
              'info.wd@setu.ie',
            SU_WELFARE_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-union',
  
            BUDGETING_LABEL:
              'SETU Student Assistance Fund / financial support',
            BUDGETING_EMAIL:
              'info.wd@setu.ie',
            BUDGETING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-assistance-fund-saf',
  
            SUPPORT_TREE_LABEL:
              'SETU Waterford Student Support Services',
            SUPPORT_TREE_URL:
              'https://www.setu.ie/current-students/student-support-services',
          },
        },
  
        carlow: {
          label: 'Carlow',
  
          tokens: {
            UNIVERSITY_REGION: 'Carlow',
  
            CAMPUS_NAME: 'Carlow',
            CAMPUS_ADDRESS:
              'Kilkenny Road, Carlow, Co. Carlow, R93 V960',
            CAMPUS_PHONE_DISPLAY:
              '+353 59 91 75000',
            CAMPUS_PHONE_TEL:
              '+353599175000',
            CAMPUS_EMAIL: 'info.cw@setu.ie',
            CAMPUS_WEBSITE:
              'https://www.setu.ie/about/setu-campuses/carlow-campus',
  
            STUDENT_HEALTH_LABEL:
              'SETU Carlow Student Medical Service',
            STUDENT_HEALTH_PHONE_DISPLAY:
              '059 917 5606',
            STUDENT_HEALTH_PHONE_TEL:
              '+353599175606',
            STUDENT_HEALTH_EMAIL:
              'info.cw@setu.ie',
            STUDENT_HEALTH_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-carlow-wexford',
  
            COUNSELLING_LABEL:
              'SETU Carlow Student Counselling Service',
            COUNSELLING_PHONE_DISPLAY:
              '059 917 5600',
            COUNSELLING_PHONE_TEL:
              '+353599175600',
            COUNSELLING_EMAIL:
              'counselling.cw@setu.ie',
            COUNSELLING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/counselling-service/counselling-service-carlow-wexford',
  
            STUDENT_HEALTH_CONTACT:
              '[059 917 5606](tel:+353599175606) or [Carlow/Wexford medical services page](https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-carlow-wexford)',
  
            COUNSELLING_CONTACT:
              '[059 917 5600](tel:+353599175600) or [counselling.cw@setu.ie](mailto:counselling.cw@setu.ie)',
  
            SU_WELFARE_LABEL:
              'SETU Students’ Union welfare/support',
            SU_WELFARE_EMAIL:
              'info.cw@setu.ie',
            SU_WELFARE_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-union',
  
            BUDGETING_LABEL:
              'SETU Student Assistance Fund / financial support',
            BUDGETING_EMAIL:
              'info.cw@setu.ie',
            BUDGETING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-assistance-fund-saf',
  
            SUPPORT_TREE_LABEL:
              'SETU Carlow Student Support Services',
            SUPPORT_TREE_URL:
              'https://www.setu.ie/current-students/student-support-services',
          },
        },
  
        wexford: {
          label: 'Wexford',
  
          tokens: {
            UNIVERSITY_REGION: 'Wexford',
  
            CAMPUS_NAME: 'Wexford',
            CAMPUS_ADDRESS:
              'Summerhill Road, Townparks, Co. Wexford, Y35 KA07',
            CAMPUS_PHONE_DISPLAY:
              '+353 53 9185800',
            CAMPUS_PHONE_TEL:
              '+353539185800',
            CAMPUS_EMAIL:
              'info.cw@setu.ie',
            CAMPUS_WEBSITE:
              'https://www.setu.ie/about/setu-campuses/visiting-the-wexford-campuses',
  
            STUDENT_HEALTH_LABEL:
              'SETU Wexford Student Medical Service',
            STUDENT_HEALTH_PHONE_DISPLAY:
              '053 918 5802',
            STUDENT_HEALTH_PHONE_TEL:
              '+353539185802',
            STUDENT_HEALTH_EMAIL:
              'info.cw@setu.ie',
            STUDENT_HEALTH_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-carlow-wexford',
  
            COUNSELLING_LABEL:
              'SETU Wexford Student Counselling Service',
            COUNSELLING_PHONE_DISPLAY:
              '053 918 5802',
            COUNSELLING_PHONE_TEL:
              '+353539185802',
            COUNSELLING_EMAIL:
              'counselling.cw@setu.ie',
            COUNSELLING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/counselling-service/counselling-service-carlow-wexford',
  
            STUDENT_HEALTH_CONTACT:
              '[053 918 5802](tel:+353539185802) or [Carlow/Wexford medical services page](https://www.setu.ie/current-students/student-support-services/medical-services/medical-services-carlow-wexford)',
  
            COUNSELLING_CONTACT:
              '[053 918 5802](tel:+353539185802) or [counselling.cw@setu.ie](mailto:counselling.cw@setu.ie)',
  
            SU_WELFARE_LABEL:
              'SETU Students’ Union welfare/support',
            SU_WELFARE_EMAIL:
              'info.cw@setu.ie',
            SU_WELFARE_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-union',
  
            BUDGETING_LABEL:
              'SETU Student Assistance Fund / financial support',
            BUDGETING_EMAIL:
              'info.cw@setu.ie',
            BUDGETING_WEBSITE:
              'https://www.setu.ie/current-students/student-support-services/student-assistance-fund-saf',
  
            SUPPORT_TREE_LABEL:
              'SETU Wexford Student Support Services',
            SUPPORT_TREE_URL:
              'https://www.setu.ie/current-students/student-support-services',
          },
        },
      },
    },
  
    tcd: {
      key: 'tcd',
  
      tokens: {
        UNIVERSITY_NAME:
          'Trinity College Dublin',
        UNIVERSITY_SHORT: 'TCD',
        UNIVERSITY_REGION: 'Dublin',
  
        STUDENT_HEALTH_LABEL:
          'Student Health Service',
        STUDENT_HEALTH_PHONE_DISPLAY:
          'Place Holder',
        STUDENT_HEALTH_PHONE_TEL:
          'Place Holder',
        STUDENT_HEALTH_EMAIL:
          'Place Holder',
        STUDENT_HEALTH_WEBSITE:
          'Place Holder',
  
        COUNSELLING_LABEL:
          'Student Counselling Service',
        COUNSELLING_PHONE_DISPLAY:
          'Place Holder',
        COUNSELLING_PHONE_TEL:
          'Place Holder',
        COUNSELLING_EMAIL:
          'Place Holder',
        COUNSELLING_WEBSITE:
          'Place Holder',
  
        STUDENT_HEALTH_CONTACT:
          'Place Holder',
        COUNSELLING_CONTACT:
          'Place Holder',
  
        CRISIS_TEXT_LABEL:
          'Text About It (24/7)',
        CRISIS_TEXT_NUMBER_DISPLAY: '50808',
        CRISIS_TEXT_NUMBER_TEL: '50808',
        CRISIS_TEXT_FORMATTED:
          'Text TALK to [50808](tel:50808)',
        CRISIS_TEXT_CONTACT:
          'Text TALK to [50808](tel:50808) (backup: [086 1800 280](tel:+353861800280))',
  
        REGIONAL_ADULT_ADDICTION_LABEL:
          'Local HSE Drug & Alcohol Service',
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY:
          'Place Holder',
        REGIONAL_ADULT_ADDICTION_PHONE_TEL:
          'Place Holder',
        REGIONAL_ADULT_ADDICTION_EMAIL:
          'Place Holder',
        REGIONAL_ADULT_ADDICTION_WEBSITE:
          'Place Holder',
  
        REGIONAL_DRUG_ALCOHOL_LABEL:
          'Local HSE Drug & Alcohol Service',
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY:
          'Place Holder',
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL:
          'Place Holder',
        REGIONAL_DRUG_ALCOHOL_EMAIL:
          'Place Holder',
        REGIONAL_DRUG_ALCOHOL_WEBSITE:
          'Place Holder',
  
        REGIONAL_TREATMENT_LABEL:
          'Local treatment/support services',
        REGIONAL_TREATMENT_PHONE_DISPLAY:
          'Place Holder',
        REGIONAL_TREATMENT_PHONE_TEL:
          'Place Holder',
        REGIONAL_TREATMENT_EMAIL:
          'Place Holder',
        REGIONAL_TREATMENT_WEBSITE:
          'Place Holder',
  
        REGIONAL_ADULT_ADDICTION_CONTACT:
          'Place Holder',
        REGIONAL_TREATMENT_CONTACT:
          'Place Holder',
  
        SUGS_LABEL: 'Place Holder',
        SUGS_EMAIL: 'Place Holder',
        SUGS_WEBSITE: 'Place Holder',
        SUGS_CONTACT: 'Place Holder',
        SUGS_SUPPORT_BULLET:
          'Place Holder',
  
        SU_WELFARE_LABEL:
          'Students’ Union welfare/support',
        SU_WELFARE_EMAIL: 'Place Holder',
        SU_WELFARE_WEBSITE:
          'Place Holder',
  
        BUDGETING_LABEL:
          'Student financial support / budgeting advice',
        BUDGETING_EMAIL:
          'Place Holder',
        BUDGETING_WEBSITE:
          'Place Holder',
  
        SUPPORT_TREE_LABEL:
          'TCD Student Support',
        SUPPORT_TREE_URL: 'Place Holder',
  
        FLAC_LABEL:
          'Free Legal Advice Centres (FLAC)',
        FLAC_PHONE_DISPLAY: '01 906 1010',
        FLAC_PHONE_TEL: '+35319061010',
      },
    },
  
    ucd: {
      key: 'ucd',
  
      tokens: {
        // ─────────────────────────────────────────────────────────────
        // A) Institution & Location
        // ─────────────────────────────────────────────────────────────
        UNIVERSITY_NAME:
          'University College Dublin',
        UNIVERSITY_SHORT: 'UCD',
        UNIVERSITY_REGION: 'Dublin',
  
        // ─────────────────────────────────────────────────────────────
        // B) University Health & Counselling
        // ─────────────────────────────────────────────────────────────
        STUDENT_HEALTH_LABEL:
          'UCD Student Health Service',
        STUDENT_HEALTH_PHONE_DISPLAY:
          '01 716 3134',
        STUDENT_HEALTH_PHONE_TEL:
          '+35317163134',
        STUDENT_HEALTH_EMAIL: '',
        STUDENT_HEALTH_WEBSITE:
          'https://www.ucd.ie/stuhealth/',
  
        COUNSELLING_LABEL:
          'UCD Student Counselling',
        COUNSELLING_PHONE_DISPLAY:
          '01 716 3159',
        COUNSELLING_PHONE_TEL:
          '+35317163159',
        COUNSELLING_EMAIL:
          'student.counselling@ucd.ie',
        COUNSELLING_WEBSITE:
          'https://www.ucd.ie/studentcounselling/',
  
        STUDENT_HEALTH_CONTACT:
          '[01 716 3134](tel:+35317163134)',
  
        COUNSELLING_CONTACT:
          '[01 716 3159](tel:+35317163159) or [student.counselling@ucd.ie](mailto:student.counselling@ucd.ie)',
  
        // ─────────────────────────────────────────────────────────────
        // C) Crisis Text Line
        // ─────────────────────────────────────────────────────────────
        CRISIS_TEXT_LABEL:
          'Crisis Text Line',
        CRISIS_TEXT_NUMBER_DISPLAY: '50808',
        CRISIS_TEXT_NUMBER_TEL: '50808',
        CRISIS_TEXT_FORMATTED:
          'Text UCD to [50808](tel:50808)',
        CRISIS_TEXT_CONTACT:
          'Text UCD to [50808](tel:50808)',
  
        // ─────────────────────────────────────────────────────────────
        // D) Regional Supports
        // ─────────────────────────────────────────────────────────────
        REGIONAL_ADULT_ADDICTION_LABEL:
          'HSE Drugs and Alcohol Helpline',
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY:
          '1800 459 459',
        REGIONAL_ADULT_ADDICTION_PHONE_TEL:
          '1800459459',
        REGIONAL_ADULT_ADDICTION_EMAIL:
          'helpline@hse.ie',
        REGIONAL_ADULT_ADDICTION_WEBSITE:
          'https://www.drugs.ie/phone/',
  
        REGIONAL_DRUG_ALCOHOL_LABEL: '',
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY: '',
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL: '',
        REGIONAL_DRUG_ALCOHOL_EMAIL: '',
        REGIONAL_DRUG_ALCOHOL_WEBSITE: '',
  
        REGIONAL_TREATMENT_LABEL:
          'Services directory',
        REGIONAL_TREATMENT_PHONE_DISPLAY: '',
        REGIONAL_TREATMENT_PHONE_TEL: '',
        REGIONAL_TREATMENT_EMAIL: '',
        REGIONAL_TREATMENT_WEBSITE:
          'http://www.services.drugs.ie/',
  
        REGIONAL_ADULT_ADDICTION_CONTACT:
          '[1800 459 459](tel:1800459459) or [helpline@hse.ie](mailto:helpline@hse.ie) or [drugs.ie/phone](https://www.drugs.ie/phone/)',
  
        REGIONAL_TREATMENT_CONTACT:
          '[services.drugs.ie](http://www.services.drugs.ie/)',
  
        // UL-only service
        SUGS_LABEL: '',
        SUGS_EMAIL: '',
        SUGS_WEBSITE: '',
        SUGS_CONTACT: '',
        SUGS_SUPPORT_BULLET: '',
  
        // ─────────────────────────────────────────────────────────────
        // E) University / Students’ Union Supports
        // ─────────────────────────────────────────────────────────────
        SU_WELFARE_LABEL:
          'Students’ Union welfare officer',
        SU_WELFARE_EMAIL:
          'welfare@ucdsu.ie',
        SU_WELFARE_WEBSITE: '',
  
        BUDGETING_LABEL:
          'Student budgeting / financial support',
        BUDGETING_EMAIL: '',
        BUDGETING_WEBSITE:
          'https://www.ucd.ie/studentadvisers/studentguides/financefees/  |  https://www.ucd.ie/studentadvisers/financialsupport/',
  
        SUPPORT_TREE_LABEL:
          'UCD Student Supports',
        SUPPORT_TREE_URL:
          'https://www.ucd.ie/studentcentre/services/studentsupport/',
  
        // ─────────────────────────────────────────────────────────────
        // F) Legal & Safety
        // ─────────────────────────────────────────────────────────────
        FLAC_LABEL:
          'FLAC Legal Advice Centre',
        FLAC_PHONE_DISPLAY: '01 906 1010',
        FLAC_PHONE_TEL: '+35319061010',
      },
    },
  
    atu: {
      key: 'atu',
    
      tokens: {
        // ─────────────────────────────────────────────────────────────
        // A) Institution & Location
        // ─────────────────────────────────────────────────────────────
        UNIVERSITY_NAME:
          'Atlantic Technological University',
    
        UNIVERSITY_SHORT:
          'ATU',
    
        UNIVERSITY_REGION:
          'West and North-West Ireland',
    
        MAIN_WEBSITE:
          'https://www.atu.ie/',
    
        // ─────────────────────────────────────────────────────────────
        // B) University Health & Counselling
        // Base values used if no campus is selected
        // ─────────────────────────────────────────────────────────────
        STUDENT_HEALTH_LABEL:
          'ATU Student Health Service',
    
        STUDENT_HEALTH_PHONE_DISPLAY:
          'See campus contact below',
    
        STUDENT_HEALTH_PHONE_TEL:
          '',
    
        STUDENT_HEALTH_EMAIL:
          'studentservices@atu.ie',
    
        STUDENT_HEALTH_WEBSITE:
          'https://www.atu.ie/student-life/student-support/student-health-service',
    
        COUNSELLING_LABEL:
          'ATU Student Counselling Service',
    
        COUNSELLING_PHONE_DISPLAY:
          'See campus contact below',
    
        COUNSELLING_PHONE_TEL:
          '',
    
        COUNSELLING_EMAIL:
          'studentservices@atu.ie',
    
        COUNSELLING_WEBSITE:
          'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
        STUDENT_HEALTH_CONTACT:
          '[ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service)',
    
        COUNSELLING_CONTACT:
          '[ATU Student Counselling Service](https://www.atu.ie/student-life/student-support/atu-student-counselling-service)',
    
        // ─────────────────────────────────────────────────────────────
        // C) Crisis Text Line
        // ─────────────────────────────────────────────────────────────
        CRISIS_TEXT_LABEL:
          'Text About It (24/7)',
    
        CRISIS_TEXT_NUMBER_DISPLAY:
          '50808',
    
        CRISIS_TEXT_NUMBER_TEL:
          '50808',
    
        CRISIS_TEXT_FORMATTED:
          'Text ATU to [50808](sms:50808)',
    
        CRISIS_TEXT_CONTACT:
          'Text ATU to [50808](sms:50808)',
    
        // ─────────────────────────────────────────────────────────────
        // D) Drug & Alcohol Supports
        //
        // ATU covers several regions, so the national HSE helpline is
        // more reliable here than pretending one regional service
        // applies to every campus.
        // ─────────────────────────────────────────────────────────────
        REGIONAL_ADULT_ADDICTION_LABEL:
          'HSE Drugs & Alcohol Helpline',
    
        REGIONAL_ADULT_ADDICTION_PHONE_DISPLAY:
          '1800 459 459',
    
        REGIONAL_ADULT_ADDICTION_PHONE_TEL:
          '1800459459',
    
        REGIONAL_ADULT_ADDICTION_EMAIL:
          'helpline@hse.ie',
    
        REGIONAL_ADULT_ADDICTION_WEBSITE:
          'https://www.drugs.ie/phone/',
    
        REGIONAL_DRUG_ALCOHOL_LABEL:
          'HSE Drugs & Alcohol Helpline',
    
        REGIONAL_DRUG_ALCOHOL_PHONE_DISPLAY:
          '1800 459 459',
    
        REGIONAL_DRUG_ALCOHOL_PHONE_TEL:
          '1800459459',
    
        REGIONAL_DRUG_ALCOHOL_EMAIL:
          'helpline@hse.ie',
    
        REGIONAL_DRUG_ALCOHOL_WEBSITE:
          'https://www.drugs.ie/phone/',
    
        REGIONAL_TREATMENT_LABEL:
          'Drugs.ie Treatment & Support Services Directory',
    
        REGIONAL_TREATMENT_PHONE_DISPLAY:
          '1800 459 459',
    
        REGIONAL_TREATMENT_PHONE_TEL:
          '1800459459',
    
        REGIONAL_TREATMENT_EMAIL:
          'helpline@hse.ie',
    
        REGIONAL_TREATMENT_WEBSITE:
          'https://www.drugs.ie/services/',
    
        REGIONAL_ADULT_ADDICTION_CONTACT:
          '[1800 459 459](tel:1800459459) or [helpline@hse.ie](mailto:helpline@hse.ie)',
    
        REGIONAL_TREATMENT_CONTACT:
          '[Drugs.ie services directory](https://www.drugs.ie/services/) or [1800 459 459](tel:1800459459)',
    
        // ─────────────────────────────────────────────────────────────
        // Generic substance-use support replacement for UL-only SUGS.
        //
        // These fields are kept populated because the shared MyUSE
        // content can reference them.
        // ─────────────────────────────────────────────────────────────
        SUGS_LABEL:
          'HSE Drugs & Alcohol Helpline',
    
        SUGS_EMAIL:
          'helpline@hse.ie',
    
        SUGS_WEBSITE:
          'https://www.drugs.ie/phone/',
    
        SUGS_CONTACT:
          '[1800 459 459](tel:1800459459) or [helpline@hse.ie](mailto:helpline@hse.ie)',
    
        SUGS_SUPPORT_BULLET:
          '* HSE Drugs & Alcohol Helpline: [1800 459 459](tel:1800459459) or [helpline@hse.ie](mailto:helpline@hse.ie)',
    
        // ─────────────────────────────────────────────────────────────
        // E) University / Students’ Union Supports
        // ─────────────────────────────────────────────────────────────
        SU_WELFARE_LABEL:
          'ATU Students’ Union welfare and wellbeing support',
    
        SU_WELFARE_EMAIL:
          'studentservices@atu.ie',
    
        SU_WELFARE_WEBSITE:
          'https://www.atu.ie/student-life',
    
        BUDGETING_LABEL:
          'ATU Student Assistance Fund / financial support',
    
        BUDGETING_EMAIL:
          'studentservices@atu.ie',
    
        BUDGETING_WEBSITE:
          'https://www.atu.ie/student-life/student-support',
    
        SUPPORT_TREE_LABEL:
          'ATU Student Support',
    
        SUPPORT_TREE_URL:
          'https://www.atu.ie/student-life/student-support',
    
        // ─────────────────────────────────────────────────────────────
        // F) Legal & Safety
        // ─────────────────────────────────────────────────────────────
        FLAC_LABEL:
          'Free Legal Advice Centres (FLAC)',
    
        FLAC_PHONE_DISPLAY:
          '01 906 1010',
    
        FLAC_PHONE_TEL:
          '+35319061010',
      },
    
      campuses: {
        // ============================================================
        // GALWAY CITY - DUBLIN ROAD
        // ============================================================
        galway_dublin_road: {
          label:
            'Galway City - Dublin Road',
    
          tokens: {
            UNIVERSITY_REGION:
              'Galway',
    
            CAMPUS_NAME:
              'Galway City - Dublin Road',
    
            CAMPUS_ADDRESS:
              'Dublin Road, Galway, H91 T8NW',
    
            CAMPUS_PHONE_DISPLAY:
              '091 753 161',
    
            CAMPUS_PHONE_TEL:
              '+35391753161',
    
            CAMPUS_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations/atu-galway-city',
    
            STUDENT_HEALTH_LABEL:
              'ATU Galway Student Medical Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '091 753 161',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+35391753161',
    
            STUDENT_HEALTH_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[091 753 161](tel:+35391753161) or [ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service)',
    
            COUNSELLING_LABEL:
              'ATU Galway Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.galway@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '091 742 118',
    
            COUNSELLING_PHONE_TEL:
              '+35391742118',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[091 742 118](tel:+35391742118) or [counselling.galway@atu.ie](mailto:counselling.galway@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Galway & Mayo Students’ Union VP Welfare',
    
            SU_WELFARE_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusugalwaymayo.ie/your-union-3/',
    
            BUDGETING_LABEL:
              'ATU Galway & Mayo student financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusugalwaymayo.ie/student-finances/',
    
            SUPPORT_TREE_LABEL:
              'ATU Galway Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // GALWAY CITY - WELLPARK
        // ============================================================
        galway_wellpark: {
          label:
            'Galway City - Wellpark Road',
    
          tokens: {
            UNIVERSITY_REGION:
              'Galway',
    
            CAMPUS_NAME:
              'Galway City - Wellpark Road',
    
            CAMPUS_ADDRESS:
              'Monivea Road, Galway, H91 DY9Y',
    
            CAMPUS_PHONE_DISPLAY:
              '091 770 661',
    
            CAMPUS_PHONE_TEL:
              '+35391770661',
    
            CAMPUS_EMAIL:
              'sdca.galwaymayo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Galway Student Medical Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '091 753 161',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+35391753161',
    
            STUDENT_HEALTH_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[091 753 161](tel:+35391753161) or [ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service)',
    
            COUNSELLING_LABEL:
              'ATU Galway Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.galway@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '091 742 118',
    
            COUNSELLING_PHONE_TEL:
              '+35391742118',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[091 742 118](tel:+35391742118) or [counselling.galway@atu.ie](mailto:counselling.galway@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Galway & Mayo Students’ Union VP Welfare',
    
            SU_WELFARE_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusugalwaymayo.ie/your-union-3/',
    
            BUDGETING_LABEL:
              'ATU Galway & Mayo student financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusugalwaymayo.ie/student-finances/',
    
            SUPPORT_TREE_LABEL:
              'ATU Galway Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // MAYO - CASTLEBAR
        // ============================================================
        mayo_castlebar: {
          label:
            'Mayo - Castlebar',
    
          tokens: {
            UNIVERSITY_REGION:
              'Mayo',
    
            CAMPUS_NAME:
              'Mayo - Castlebar',
    
            CAMPUS_ADDRESS:
              'Westport Road, Castlebar, Co. Mayo',
    
            CAMPUS_PHONE_DISPLAY:
              '094 902 5700',
    
            CAMPUS_PHONE_TEL:
              '+353949025700',
    
            CAMPUS_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Mayo Student Health Support',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '094 902 5700',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+353949025700',
    
            STUDENT_HEALTH_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[094 902 5700](tel:+353949025700) or [ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service)',
    
            COUNSELLING_LABEL:
              'ATU Mayo Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.mayo@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '094 902 5700',
    
            COUNSELLING_PHONE_TEL:
              '+353949025700',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[counselling.mayo@atu.ie](mailto:counselling.mayo@atu.ie) or [094 902 5700](tel:+353949025700)',
    
            SU_WELFARE_LABEL:
              'ATU Galway & Mayo Students’ Union Mayo support',
    
            SU_WELFARE_EMAIL:
              'sumayo.galwaymayo@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusugalwaymayo.ie/your-union-3/',
    
            BUDGETING_LABEL:
              'ATU Galway & Mayo student financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusugalwaymayo.ie/student-finances/',
    
            SUPPORT_TREE_LABEL:
              'ATU Mayo Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // MOUNTBELLEW
        // ============================================================
        mountbellew: {
          label:
            'Mountbellew',
    
          tokens: {
            UNIVERSITY_REGION:
              'Galway',
    
            CAMPUS_NAME:
              'Mountbellew',
    
            CAMPUS_ADDRESS:
              'Mountbellew, Ballinasloe, Co. Galway, H53 WE00',
    
            CAMPUS_PHONE_DISPLAY:
              '090 967 9205',
    
            CAMPUS_PHONE_TEL:
              '+353909679205',
    
            CAMPUS_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations/atu-mountbellew',
    
            STUDENT_HEALTH_LABEL:
              'ATU Galway-Mayo Student Health Support',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '091 753 161',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+35391753161',
    
            STUDENT_HEALTH_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service) or [091 753 161](tel:+35391753161)',
    
            COUNSELLING_LABEL:
              'ATU Galway Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.galway@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '091 742 118',
    
            COUNSELLING_PHONE_TEL:
              '+35391742118',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[091 742 118](tel:+35391742118) or [counselling.galway@atu.ie](mailto:counselling.galway@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Galway & Mayo Students’ Union welfare support',
    
            SU_WELFARE_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusugalwaymayo.ie/your-union-3/',
    
            BUDGETING_LABEL:
              'ATU Galway & Mayo student financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusugalwaymayo.ie/student-finances/',
    
            SUPPORT_TREE_LABEL:
              'ATU Galway-Mayo Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // CONNEMARA - LETTERFRACK
        // ============================================================
        connemara_letterfrack: {
          label:
            'Connemara - Letterfrack',
    
          tokens: {
            UNIVERSITY_REGION:
              'Galway',
    
            CAMPUS_NAME:
              'Connemara - Letterfrack',
    
            CAMPUS_ADDRESS:
              'Letterfrack, Co. Galway, H91 AH5K',
    
            CAMPUS_PHONE_DISPLAY:
              '091 742 650',
    
            CAMPUS_PHONE_TEL:
              '+35391742650',
    
            CAMPUS_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Galway-Mayo Student Health Support',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '091 753 161',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+35391753161',
    
            STUDENT_HEALTH_EMAIL:
              'reception.galwaymayo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[ATU Student Health Service](https://www.atu.ie/student-life/student-support/student-health-service) or [091 753 161](tel:+35391753161)',
    
            COUNSELLING_LABEL:
              'ATU Galway Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.galway@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '091 742 118',
    
            COUNSELLING_PHONE_TEL:
              '+35391742118',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[091 742 118](tel:+35391742118) or [counselling.galway@atu.ie](mailto:counselling.galway@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Galway & Mayo Students’ Union welfare support',
    
            SU_WELFARE_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusugalwaymayo.ie/your-union-3/',
    
            BUDGETING_LABEL:
              'ATU Galway & Mayo student financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.galwaymayo@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusugalwaymayo.ie/student-finances/',
    
            SUPPORT_TREE_LABEL:
              'ATU Galway-Mayo Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // SLIGO
        // ============================================================
        sligo: {
          label:
            'Sligo',
    
          tokens: {
            UNIVERSITY_REGION:
              'Sligo',
    
            CAMPUS_NAME:
              'Sligo',
    
            CAMPUS_ADDRESS:
              'Ash Lane, Sligo, Co. Sligo',
    
            CAMPUS_PHONE_DISPLAY:
              '071 915 5222',
    
            CAMPUS_PHONE_TEL:
              '+353719155222',
    
            CAMPUS_EMAIL:
              'studentreg.sligo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Sligo Student Health Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '071 930 5463',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+353719305463',
    
            STUDENT_HEALTH_EMAIL:
              'studenthealthservices.sligo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[071 930 5463](tel:+353719305463) or [studenthealthservices.sligo@atu.ie](mailto:studenthealthservices.sligo@atu.ie)',
    
            COUNSELLING_LABEL:
              'ATU Sligo Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'studentcounsellingservices.sligo@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '071 930 5463',
    
            COUNSELLING_PHONE_TEL:
              '+353719305463',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[071 930 5463](tel:+353719305463) or [studentcounsellingservices.sligo@atu.ie](mailto:studentcounsellingservices.sligo@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Sligo Students’ Union Wellbeing & Engagement',
    
            SU_WELFARE_EMAIL:
              'support@atussu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atussu.ie/',
    
            BUDGETING_LABEL:
              'ATU Sligo Student Assistance Fund',
    
            BUDGETING_EMAIL:
              'support@atussu.ie',
    
            BUDGETING_WEBSITE:
              'https://atussu.ie/your-union/faqs/',
    
            SUPPORT_TREE_LABEL:
              'ATU Sligo Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // ST ANGELA'S
        // ============================================================
        st_angelas: {
          label:
            "St Angela's",
    
          tokens: {
            UNIVERSITY_REGION:
              'Sligo',
    
            CAMPUS_NAME:
              "St Angela's",
    
            CAMPUS_ADDRESS:
              "St Angela's Campus, Lough Gill, Co. Sligo",
    
            CAMPUS_PHONE_DISPLAY:
              '071 914 3580',
    
            CAMPUS_PHONE_TEL:
              '+353719143580',
    
            CAMPUS_EMAIL:
              'studentreg.sligo@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Sligo Student Health Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '071 930 5463',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+353719305463',
    
            STUDENT_HEALTH_EMAIL:
              'studenthealthservices.sligo@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[071 930 5463](tel:+353719305463) or [studenthealthservices.sligo@atu.ie](mailto:studenthealthservices.sligo@atu.ie)',
    
            COUNSELLING_LABEL:
              'ATU Sligo Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'studentcounsellingservices.sligo@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '071 930 5463',
    
            COUNSELLING_PHONE_TEL:
              '+353719305463',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[071 930 5463](tel:+353719305463) or [studentcounsellingservices.sligo@atu.ie](mailto:studentcounsellingservices.sligo@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Sligo Students’ Union Wellbeing & Engagement',
    
            SU_WELFARE_EMAIL:
              'support@atussu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atussu.ie/',
    
            BUDGETING_LABEL:
              'ATU Sligo Student Assistance Fund',
    
            BUDGETING_EMAIL:
              'support@atussu.ie',
    
            BUDGETING_WEBSITE:
              'https://atussu.ie/your-union/faqs/',
    
            SUPPORT_TREE_LABEL:
              "ATU St Angela's Student Support",
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // DONEGAL - LETTERKENNY
        // ============================================================
        donegal_letterkenny: {
          label:
            'Donegal - Letterkenny',
    
          tokens: {
            UNIVERSITY_REGION:
              'Donegal',
    
            CAMPUS_NAME:
              'Donegal - Letterkenny',
    
            CAMPUS_ADDRESS:
              'Port Road, Letterkenny, Co. Donegal',
    
            CAMPUS_PHONE_DISPLAY:
              '074 918 6000',
    
            CAMPUS_PHONE_TEL:
              '+353749186000',
    
            CAMPUS_EMAIL:
              'reception.donegal@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Donegal Student Health Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '074 918 6855',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+353749186855',
    
            STUDENT_HEALTH_EMAIL:
              'health.donegal@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[074 918 6855](tel:+353749186855) or [health.donegal@atu.ie](mailto:health.donegal@atu.ie)',
    
            COUNSELLING_LABEL:
              'ATU Donegal Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.donegal@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '074 918 6855',
    
            COUNSELLING_PHONE_TEL:
              '+353749186855',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[074 918 6855](tel:+353749186855) or [counselling.donegal@atu.ie](mailto:counselling.donegal@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Donegal Students’ Union Welfare & Equality',
    
            SU_WELFARE_EMAIL:
              'suwelfare.donegal@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusudonegal.ie/welfare-equality-officer/',
    
            BUDGETING_LABEL:
              'ATU Donegal Student Assistance Fund / financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.donegal@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusudonegal.ie/',
    
            SUPPORT_TREE_LABEL:
              'ATU Donegal Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
    
        // ============================================================
        // DONEGAL - KILLYBEGS
        // ============================================================
        donegal_killybegs: {
          label:
            'Donegal - Killybegs',
    
          tokens: {
            UNIVERSITY_REGION:
              'Donegal',
    
            CAMPUS_NAME:
              'Donegal - Killybegs',
    
            CAMPUS_ADDRESS:
              'Shore Road, Killybegs, Co. Donegal',
    
            CAMPUS_PHONE_DISPLAY:
              '074 918 6000',
    
            CAMPUS_PHONE_TEL:
              '+353749186000',
    
            CAMPUS_EMAIL:
              'reception.donegal@atu.ie',
    
            CAMPUS_WEBSITE:
              'https://www.atu.ie/locations',
    
            STUDENT_HEALTH_LABEL:
              'ATU Donegal Student Health Service',
    
            STUDENT_HEALTH_PHONE_DISPLAY:
              '074 918 6855',
    
            STUDENT_HEALTH_PHONE_TEL:
              '+353749186855',
    
            STUDENT_HEALTH_EMAIL:
              'health.donegal@atu.ie',
    
            STUDENT_HEALTH_WEBSITE:
              'https://www.atu.ie/student-life/student-support/student-health-service',
    
            STUDENT_HEALTH_CONTACT:
              '[074 918 6855](tel:+353749186855) or [health.donegal@atu.ie](mailto:health.donegal@atu.ie)',
    
            COUNSELLING_LABEL:
              'ATU Donegal Student Counselling Service',
    
            COUNSELLING_EMAIL:
              'counselling.donegal@atu.ie',
    
            COUNSELLING_PHONE_DISPLAY:
              '074 918 6855',
    
            COUNSELLING_PHONE_TEL:
              '+353749186855',
    
            COUNSELLING_WEBSITE:
              'https://www.atu.ie/student-life/student-support/atu-student-counselling-service',
    
            COUNSELLING_CONTACT:
              '[074 918 6855](tel:+353749186855) or [counselling.donegal@atu.ie](mailto:counselling.donegal@atu.ie)',
    
            SU_WELFARE_LABEL:
              'ATU Donegal Students’ Union Welfare & Equality',
    
            SU_WELFARE_EMAIL:
              'suwelfare.donegal@atu.ie',
    
            SU_WELFARE_WEBSITE:
              'https://atusudonegal.ie/welfare-equality-officer/',
    
            BUDGETING_LABEL:
              'ATU Donegal Student Assistance Fund / financial support',
    
            BUDGETING_EMAIL:
              'suwelfare.donegal@atu.ie',
    
            BUDGETING_WEBSITE:
              'https://atusudonegal.ie/',
    
            SUPPORT_TREE_LABEL:
              'ATU Donegal Student Support',
    
            SUPPORT_TREE_URL:
              'https://www.atu.ie/student-life/student-support',
          },
        },
      },
    },
  }
  
  export const DEFAULT_TENANT_KEY = 'ucc'
  
  export function resolveTenantKeyFromHost(
    host
  ) {
    const clean = String(
      host || ''
    )
      .toLowerCase()
      .split(':')[0]
  
    const sub =
      clean.split('.')[0]
  
    return TENANTS[sub]
      ? sub
      : DEFAULT_TENANT_KEY
  }
  

  /**
 * Convert a tenant value into a valid tenant key.
 *
 * Unknown, empty and infrastructure host values fall back to UCC.
 */
export function normaliseTenantKey(
    tenantKey
  ) {
    const key = String(
      tenantKey || ''
    )
      .trim()
      .toLowerCase()
  
    // tool.myuse.ie is the central/default frontend,
    // not a separate tenant.
    if (
      !key ||
      key === 'tool' ||
      key === 'www' ||
      key === 'api' ||
      key === 'admin' ||
      key === 'localhost'
    ) {
      return DEFAULT_TENANT_KEY
    }
  
    return TENANTS[key]
      ? key
      : DEFAULT_TENANT_KEY
  }
  
  /**
   * Return the campuses configured for a tenant.
   */
  export function getTenantCampuses(
    tenantKey
  ) {
    const key =
      normaliseTenantKey(tenantKey)
  
    const tenant =
      TENANTS[key] ||
      TENANTS[DEFAULT_TENANT_KEY]
  
    return tenant.campuses || {}
  }
  
  /**
   * Determine whether the tenant requires/allows a campus picker.
   */
  export function hasCampusPicker(
    tenantKey
  ) {
    return (
      Object.keys(
        getTenantCampuses(
          tenantKey
        )
      ).length > 0
    )
  }
  
  /**
   * Return merged localisation tokens.
   *
   * Campus tokens override the tenant's base tokens.
   */
  export function getTenantTokens(
    tenantKey,
    campusKey = null
  ) {
    const key =
      normaliseTenantKey(tenantKey)
  
    const tenant =
      TENANTS[key] ||
      TENANTS[DEFAULT_TENANT_KEY]
  
    const baseTokens = {
      ...(tenant.tokens || {}),
    }
  
    if (!campusKey) {
      return baseTokens
    }
  
    const normalisedCampus =
      String(campusKey)
        .trim()
        .toLowerCase()
  
    const campus =
      tenant.campuses &&
      tenant.campuses[
        normalisedCampus
      ]
  
    if (
      !campus ||
      !campus.tokens
    ) {
      return baseTokens
    }
  
    return {
      ...baseTokens,
      ...campus.tokens,
    }
  }
  
  /**
   * Return a runtime tenant configuration.
   *
   * A new object is returned so campus-specific token merging does not mutate
   * the original TENANTS constant.
   */
  export function getTenantConfig(
    tenantKey,
    campusKey = null
  ) {
    const key =
      normaliseTenantKey(tenantKey)
  
    const source =
      TENANTS[key] ||
      TENANTS[DEFAULT_TENANT_KEY]
  
    const campuses =
      source.campuses || {}
  
    const normalisedCampus =
      campusKey == null ||
      campusKey === ''
        ? null
        : String(campusKey)
            .trim()
            .toLowerCase()
  
    const selectedCampus =
      normalisedCampus &&
      campuses[normalisedCampus]
        ? {
            key:
              normalisedCampus,
  
            ...campuses[
              normalisedCampus
            ],
          }
        : null
  
    return {
      ...source,
  
      key,
  
      tokens:
        getTenantTokens(
          key,
          normalisedCampus
        ),
  
      campuses,
  
      campus_key:
        selectedCampus
          ? selectedCampus.key
          : null,
  
      campus_label:
        selectedCampus
          ? selectedCampus.label
          : null,
  
      selectedCampus,
    }
  }